import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyRefundBill from './pharmacy-refund-bill';
import PharmacyRefundBillDetail from './pharmacy-refund-bill-detail';
import PharmacyRefundBillUpdate from './pharmacy-refund-bill-update';
import PharmacyRefundBillDeleteDialog from './pharmacy-refund-bill-delete-dialog';

const PharmacyRefundBillRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyRefundBill />} />
    <Route path="new" element={<PharmacyRefundBillUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyRefundBillDetail />} />
      <Route path="edit" element={<PharmacyRefundBillUpdate />} />
      <Route path="delete" element={<PharmacyRefundBillDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyRefundBillRoutes;
